import React from "react";

const ShipmentContext = React.createContext(null);

export default ShipmentContext;
